<template>
  <div>
    <v-card id="card-modal-assign-vehicle" class="elevation-4">
      <v-card-title class="justify-start py-2 card-modaltitle">
        <div class="pl-4">
          <h3 class="primary--text title--text">
            {{ $t('components.views.trip.active.modal_edit.title') }}
          </h3>
        </div>
        <v-btn depressed text color="primary" class="cont" @click.stop="onCancel">
          <v-icon class="mr-1">fa-solid fa-xmark</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form v-model="valida" dense>
          <v-container fluid class="pl-2">
            <v-row class="justify-center">
              <v-col cols="12" class="pb-0">
                <SelectAutocomplete :selected="companySelected" :data="companyData" :init="false"
                  item-text="businessName" item-value="businessName" dense prepend-icon="fa-solid fa-building"
                  :label="$t('components.views.trip.no_offer_assign.modal_assign.business_transport')" disabled
                  hide-details
                  :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.business_transport')" />
              </v-col>
            </v-row>

            <v-row class="justify-center">
              <v-col cols="12" class="pb-0">
                <SelectAutocomplete ref="driver" v-model="driver" url="/Drivers" dense return-object
                  item-text="identification" item-value="identification" required prepend-icon="fa-solid fa-id-card"
                  :label="$t('components.views.trip.no_offer_assign.modal_assign.identification_number')"
                  :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.identification_number')"
                  hide-details maxlength="15" :search-input.sync="driverCreate"
                  :selected="trip && trip.driver ? trip.driver.identification : ''" @click:clear="cleanFieldDriver()">
                  <template slot="no-data">
                    <v-list-item @click="loadModalNewDriver()">
                      <v-list-item-title>
                        {{ $t('components.views.trip.no_offer_assign.modal_assign.create_new_driver') }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </SelectAutocomplete>
              </v-col>
            </v-row>

            <v-row class="justify-center">
              <v-col cols="12" class="pt-2 pb-0">
                <v-text-field v-model="driverNameComputed" required outlined dense readonly hide-details
                  :label="$t('components.views.trip.no_offer_assign.modal_assign.names_last_names')"
                  :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.names_last_names')"
                  prepend-icon="fa-solid fa-user" />
              </v-col>
            </v-row>

            <v-row class="justify-center">
              <v-col cols="10" class="pb-0">
                <SelectAutocomplete ref="vehicle" v-model="vehicle" :url="urlVehicle" return-object dense
                  item-text="licensePlate" item-value="licensePlate" maxlength="10" :search-input.sync="vehicleCreate"
                  prepend-icon="fa-solid fa-truck-moving"
                  :label="$t('components.views.trip.no_offer_assign.modal_assign.license_plate')"
                  :selected="selectedVehiclePlate" required @change="infoGeneral()"
                  :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.license_plate')" hide-details>
                  <template slot="no-data">
                    <v-list-item @click="loadModalNewVehicle()">
                      <v-list-item-title>
                        {{ $t('components.views.trip.no_offer_assign.modal_assign.create_new_vehicle') }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </SelectAutocomplete>
              </v-col>
              <v-col cols="2" class="pt-7 pb-0">
                <v-tooltip bottom color="primary" v-if="userGPS !== undefined">
                  <template v-slot:activator="{ on, attrs }">
                    <div id="stateGPSColor" v-bind="attrs"
                      :style="{ backgroundColor: backgroundColorStateGps, color: colorFontStateGps }"
                      style="background-color: gray; color: #fff" v-on="on">
                      GPS
                    </div>
                  </template>
                  <div id="info_gps">
                    <b>{{ $t('components.views.trip.no_offer_assign.modal_assign.user_gps') }} :</b>
                    <span>{{ userGPS }}</span>
                    <br />
                    <b>{{ $t('components.views.trip.no_offer_assign.modal_assign.date_gps') }} :</b>
                    <span>{{ dateLastGPS }}</span>
                  </div>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-row class="justify-center">
              <v-col cols="12" class="pb-0">
                <SelectAutocomplete ref="trailer" v-model="trailer" :data="filteredTrailersWithSelected" :init="false"
                  return-object dense item-text="licensePlate" item-value="licensePlate" maxlength="10"
                  :search-input.sync="trailerCreate" prepend-icon="fa-solid fa-trailer"
                  :label="$t('components.views.trip.no_offer_assign.modal_assign.trailer_plate')"
                  :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.trailer_plate')" hide-details
                  :selected="selectedTrailer" clearable>
                  <template slot="no-data">
                    <v-list-item @click="loadModalNewTrailer()">
                      <v-list-item-title>
                        {{ $t('components.views.trip.no_offer_assign.modal_assign.create_new_trailer') }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </SelectAutocomplete>
              </v-col>
            </v-row>

            <v-row class="justify-center">
              <v-col cols="12" class="pt-2 pb-0">
                <v-text-field v-model="typology" outlined readonly dense hide-details
                  :label="$t('components.views.trip.no_offer_assign.modal_assign.type_vehicle')"
                  :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.type_vehicle')"
                  prepend-icon="fa-solid fa-bullseye" />
              </v-col>
            </v-row>

            <v-row class="contaaner__btn pr-2">
              <v-col cols="auto" class="pa-3">
                <v-btn color="secondary" style="height: 35px;" :disabled="!valida || isSubmitting" depressed
                  @click="submitEdit" :loading="isSubmitting">
                  <v-icon class="mr-2" small>fa-solid fa-pen</v-icon>
                  {{ $t('components.views.trip.active.modal_edit.edit') }}
                </v-btn>
              </v-col>
              <v-col cols="auto" class="pa-3">
                <v-btn text color="grey" class="btn-back" style="height: 35px;" depressed @click.stop="onCancel">
                  <v-icon class="mr-2" small>fa-solid fa-xmark</v-icon>
                  {{ $t('components.views.trip.active.modal_edit.back') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogDriver" scrollable width="35%" persistent>
      <ModalCreateDriver :idDriver="driverCapture" :idCompany="idCompanyTransporter" @closeForm="onCloseFormDriver()"
        @driverCreated="onDriverCreated" />
    </v-dialog>

    <v-dialog v-model="dialogVehicle" scrollable width="20%" persistent>
      <ModalCreateVehicle :idLicensePlate="vehicleCapture" :idCompany="idCompanyTransporter" :key="index"
        @closeForm="onCloseFormVehicle()" @vehicleCreated="onVehicleCreated" />
    </v-dialog>

    <v-dialog v-model="dialogTrailer" scrollable width="20%" persistent>
      <ModalCreateTrailer :idLicensePlate="trailerCapture" :idCompany="idCompanyTransporter" :key="index"
        @closeForm="onCloseFormTrailer()" @trailerCreated="onTrailerCreated" />
    </v-dialog>

    <v-dialog v-model="dialogDocsAlert" scrollable width="40%" persistent>
      <DriverDocumentsAlertModal :driverName="docsAlertData.driverName" :documents="docsAlertData.documents"
        @close="onCloseDocsAlert" />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {
    ModalCreateDriver: () =>
      import(
        /* webpackChunkName: "ModalCreateDriver" */ "@/components/views/Trip/NoOfferAssign/ModalCreateDriver.vue"
      ),
    ModalCreateVehicle: () =>
      import(
        /* webpackChunkName: "ModalCreateVehicle" */ "@/components/views/Trip/NoOfferAssign/ModalCreateVehicle.vue"
      ),
    ModalCreateTrailer: () =>
      import(
        /* webpackChunkName: "ModalCreateTrailer" */ "@/components/views/Trip/NoOfferAssign/ModalCreateTrailer.vue"
      ),
    DriverDocumentsAlertModal: () =>
      import(
        /* webpackChunkName: "DriverDocumentsAlertModal" */ "@/components/views/Trip/modals/DriverDocumentsAlertModal.vue"
      ),
  },
  props: {
    idMonitoringOrder: {
      type: Number,
      default: 0,
    },
    trip: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      valida: true,
      typology: "",
      vehicle: {},
      gps: { stateGPS: 2, username: "", dateGPS: "" },
      company: {},
      companySelectedInternal: "",
      driverName: "",
      driverCreate: null,
      driverCapture: "",
      vehicleCreate: null,
      vehicleCapture: "",
      trailer: {},
      trailerCreate: null,
      trailerCapture: "",
      driver: {},
      allVehicles: [],
      dialogDriver: false,
      dialogVehicle: false,
      dialogTrailer: false,
      dialogDocsAlert: false,
      docsAlertData: { driverName: '', documents: [] },
      index: 1,
      idCompanyTransporter: null,
      isSubmitting: false,
    };
  },
  computed: {
    urlVehicle() {
      return `/Vehicles`;
    },
    selectedVehiclePlate() {
      return this.trip && this.trip.licensePlate ? this.trip.licensePlate : "";
    },
    selectedTrailer() {
      return this.trailer && this.trailer.licensePlate ? this.trailer : '';
    },
    companySelected() {
      return this.companySelectedInternal;
    },
    companyData() {
      const name = this.trip && this.trip.nameTransportCompany ? this.trip.nameTransportCompany : "";
      const id = this.trip && this.trip.idTransporter ? this.trip.idTransporter : null;
      return name ? [{ businessName: name, idCompany: id }] : [];
    },
    backgroundColorStateGps() {
      return this.gps.stateGPS == 0
        ? "green"
        : this.gps.stateGPS == 1
          ? "yellow"
          : this.gps.stateGPS == 2
            ? "silver"
            : "silver";
    },
    colorFontStateGps() {
      return this.gps.stateGPS == 0
        ? "#FFFFFF"
        : this.gps.stateGPS == 1
          ? "#000000"
          : this.gps.stateGPS == 2
            ? "#FFFFFF"
            : "#FFFFFF";
    },
    userGPS() {
      return this.gps.username !== "" ? this.gps.username : "";
    },
    dateLastGPS() {
      return this.gps.dateGPS !== "" ? this.gps.dateGPS : "";
    },
    driverNameComputed() {
      return this.driverName !== "" ? this.driverName : "";
    },
    filteredTrailers() {
      return this.allVehicles.filter((vehicle) => vehicle.idVehicleClass === 15);
    },
    filteredTrailersWithSelected() {
      const list = this.filteredTrailers || [];
      const plate = this.trip && this.trip.trailerPlate ? this.trip.trailerPlate : '';
      if (!plate) return list;
      const exists = list.some(v => v.licensePlate === plate);
      return exists ? list : [...list, { licensePlate: plate }];
    },
  },
  watch: {
    driver(newVal) {
      if (newVal) {
        this.driverName = `${this.driver.name || ""} ${this.driver.lastName || ""}`.trim();
        this.validateDriverCertificate();
      }
    },
    trip: {
      handler(val) {
        this.prefillFromTrip(val);
      },
      immediate: true,
      deep: true,
    },
    idMonitoringOrder(val) {
      if (val && this.$refs && this.$refs.vehicle) {
        this.$refs.vehicle.loadData();
      }
    },
    filteredTrailers(newVal) {
      if (!newVal || newVal.length === 0) return;
      const plate = this.trip && this.trip.trailerPlate ? this.trip.trailerPlate : '';
      if (!plate) return;
      const found = newVal.find(v => v.licensePlate === plate);
      if (found) {
        this.trailer = { ...found };
      }
    },
  },
  mounted() {
    this.loadAllVehicles();
    this.prefillFromTrip(this.trip);
    this.$nextTick(() => {
      if (this.$refs.driver) this.$refs.driver.loadData();
      if (this.$refs.vehicle) this.$refs.vehicle.loadData();
    });
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    buildUpdatePayload() {
      const number =
        (this.trip && (this.trip.tripNumber || this.trip.number_travel_main)) || "";

      const idCompany =
        this.idCompanyTransporter ||
        (this.trip && this.trip.idTransporter) ||
        null;
      return {
        number_travel_main: number,
        id_company: idCompany,
        modifications: [
          {
            field_name: "license_plate",
            new_value: (this.vehicle && this.vehicle.licensePlate) || ""
          },
          {
            field_name: "identification_driver",
            new_value: (this.driver && this.driver.identification) || ""
          },
          {
            field_name: "name_driver",
            new_value: (this.driver && this.driver.name) || ""
          },
          {
            field_name: "last_name_driver",
            new_value: (this.driver && this.driver.lastName) || ""
          },
          {
            field_name: "phone_driver",
            new_value: (this.driver && this.driver.phone) || ""
          },
          {
            field_name: "trailer_plate",
            new_value: (this.trailer && this.trailer.licensePlate) || ""
          }
        ]
      };
    },
    async submitEdit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        const payload = this.buildUpdatePayload();
        if (!payload.modifications || payload.modifications.length === 0) {
          this.showSnack({
            text: 'No hay cambios para actualizar',
            title: 'Sin cambios',
            name: 'warning',
          });
          return;
        }
        await this.axios.put('/Travels/UpdateTravelConfirmed', payload);
        this.trip.licensePlate = this.vehicle.licensePlate;
        this.trip.trailerPlate = this.trailer?.licensePlate ?? '';
        this.trip.driver.name = this.driver.name;
        this.prefillFromTrip(this.trip);
        this.showSnack({
          text: 'El viaje fue actualizado correctamente',
          title: 'Actualización',
          name: 'success',
        });
        this.$emit('closeForm');
      } catch (error) {
        const msg = (error && error.response && error.response.data) ? error.response.data : 'Error al actualizar el viaje';
        this.showSnack({
          text: msg,
          title: 'Error',
          name: 'error',
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    async loadAllVehicles() {
      try {
        const response = await this.axios.get('/Vehicles');
        this.allVehicles = response.data || [];
      } catch (error) {
        console.error('Error loading vehicles:', error);
        this.allVehicles = [];
      }
    },
    async prefillFromTrip(trip) {
      if (!trip || !trip.idMonitoringOrder) return;
      this.idCompanyTransporter = trip.idTransporter || null;
      this.companySelectedInternal = trip.nameTransportCompany || '';
      this.driver = trip.driver ? { ...trip.driver } : {};
      this.driverName = trip.driver ? `${trip.driver.name || ''} ${trip.driver.lastName || ''}`.trim() : '';
      if (!this.allVehicles || this.allVehicles.length === 0) {
        await this.loadAllVehicles();
      }
      const foundVehicle = this.allVehicles.find(v => v.licensePlate === trip.licensePlate);
      this.vehicle = foundVehicle ? { ...foundVehicle } : (trip.licensePlate ? { licensePlate: trip.licensePlate } : {});
      const foundTrailer = this.allVehicles.find(v => v.licensePlate === trip.trailerPlate && v.idVehicleClass === 15);
      this.trailer = foundTrailer ? { ...foundTrailer } : (trip.trailerPlate ? { licensePlate: trip.trailerPlate } : {});
      if (this.vehicle && this.vehicle.licensePlate) {
        this.infoGeneral();
      }
    },
    async showTypeVehicle() {
      let idVehicleTypology = this.vehicle && this.vehicle.idVehicleTypology != null ? this.vehicle.idVehicleTypology : '0';
      await this.axios.get(`/Vehicles/typology/${idVehicleTypology}`).then((result) => {
        this.typology = result.data;
      });
    },
    async showGpsVehicle() {
      let licensePlate = this.vehicle && this.vehicle.licensePlate != null ? this.vehicle.licensePlate : '0';
      await this.axios.get(`/Vehicles/gps/${licensePlate}`).then((result) => {
        this.gps = result.data;
      });
    },
    infoGeneral() {
      this.showTypeVehicle();
      this.showGpsVehicle();
    },
    onOpenFormDriver() {
      this.dialogDriver = true;
    },
    onCloseFormDriver() {
      this.dialogDriver = false;
    },
    async onDriverCreated(data) {
      if (data) {
        await this.$refs.driver.loadData();
        const list = (this.$refs.driver && this.$refs.driver.givens) || [];
        this.driver = list.find((d) => d && d.identification === data) || { identification: data };
      }
    },
    loadModalNewDriver() {
      this.driverCapture = this.driverCreate;
      this.onOpenFormDriver();
    },
    onOpenFormVehicle() {
      this.dialogVehicle = true;
    },
    onCloseFormVehicle() {
      this.dialogVehicle = false;
    },
    async onVehicleCreated(data) {
      if (data) {
        await this.$refs.vehicle.loadData();
        const list = (this.$refs.vehicle && this.$refs.vehicle.givens) || [];
        const found = list.find((v) => v && v.licensePlate === data);
        this.vehicle = found ? { ...found } : { licensePlate: data };
        this.infoGeneral();
      }
    },
    loadModalNewVehicle() {
      this.index++;
      this.vehicleCapture = this.vehicleCreate;
      this.onOpenFormVehicle();
    },
    onOpenFormTrailer() {
      this.dialogTrailer = true;
    },
    onCloseFormTrailer() {
      this.dialogTrailer = false;
    },
    async onTrailerCreated(data) {
      if (data) {
        await this.loadAllVehicles();
      }
    },
    loadModalNewTrailer() {
      this.index++;
      this.trailerCapture = this.trailerCreate;
      this.onOpenFormTrailer();
    },
    async validateDriverCertificate() {
      if (!this.driver || !this.driver.idDriver) {
        return;
      }

      try {
        const response = await this.axios.get(`/Drivers/validateDriver/${this.driver.idDriver}`);
        const validateData = response.data;
        const documents = Array.isArray(validateData.documentList) ? validateData.documentList : [];
        if (documents.length > 0) {
          const today = new Date();
          const expiredDocs = documents.filter(doc => {
            if (!doc) return false;
            if (!doc.dateExpiration) return true;
            const exp = new Date(doc.dateExpiration);
            return !isNaN(exp.getTime()) && exp < today;
          });

          const docsWithoutDate = documents.filter(doc => doc && !doc.dateExpiration);

          if (expiredDocs.length > 0) {
            this.showDriverValidationAlert(validateData, expiredDocs);
          } else if (!validateData.certificate && docsWithoutDate.length > 0) {
            this.showDriverValidationAlert(validateData, docsWithoutDate);
          }
        }
      } catch (error) {
        console.error('Error validating driver:', error);
        this.showSnack({
          text: 'Error de validación',
          title: 'Error al validar el conductor',
          name: 'error',
        });
      }
    },
    async showDriverValidationAlert(validateData, expiredDocs) {
      try {
        const driverName = `${validateData.name} ${validateData.lastName}`;
        this.docsAlertData = { driverName, documents: expiredDocs };
        this.dialogDocsAlert = true;
      } catch (error) {
        console.error('Error in showDriverValidationAlert:', error);
        this.showSnack({
          text: 'Error en la validación del conductor',
          title: 'Error',
          name: 'error'
        });
        this.driver = null;
      }
    },
    onCloseDocsAlert() {
      this.dialogDocsAlert = false;
      this.driver = null;
      this.cleanFieldDriver();
    },
    cleanFieldDriver() {
      this.driverName = "";
      this.driver = {};
    },
    onCancel() {
      this.prefillFromTrip(this.trip);
      this.driverCreate = null;
      this.vehicleCreate = null;
      this.trailerCreate = null;
      this.driverCapture = "";
      this.vehicleCapture = "";
      this.trailerCapture = "";
      this.dialogDriver = false;
      this.dialogVehicle = false;
      this.dialogTrailer = false;
      this.dialogDocsAlert = false;
      this.isSubmitting = false;
      this.$emit('closeForm');
    },
  },
};
</script>

<style scoped>
.title--text {
  font-size: 20px;
}

#card-modal-assign-vehicle {
  border: 3px solid #0b0045 !important;
  height: 480px;
}

.v-divider {
  border-width: 1px !important;
}

#card-modal-assign-vehicle p {
  font-size: 1.17em !important;
}

.cont {
  position: absolute;
  right: 10px;
}

#stateGPSColor {
  display: block;
  width: 100%;
  text-align: center;
  height: 23px;
  padding-top: 1px;
  border-radius: 10px;
}

#info_gps {
  font-size: 0.9em;
}

.card-modaltitle {
  border-bottom: 1px solid #ccc;
}

.contaaner__btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.btn-back {
  font-weight: 600;
  letter-spacing: 0.5px;
}
</style>
